import { useRef, useContext, useState, useEffect } from 'react';
import ButtonContent from './button-content';
import FitButton from './fit-button';
import Input from './input';
import Modal from './modal';
import FileContext from '../../contexts/files-context';
import Spinner from './spinner';
import Tooltips from './tooltip';
import { onCreateFolder } from '../../lib/files';

const CreateFolderModal = ({ isModalOpen, toggleModal, onCreate }) => {
    const inputRef = useRef(null);

    const [isCreatingFolder, setIsCreatingFolder] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [showError, setShowError] = useState(false);

     useEffect(() => {
        if (isModalOpen && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isModalOpen]);

    const handleCreateFolder = () => {
        onCreate(inputValue, toggleModal());
    }
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && inputValue.trim() !== '') {
            handleCreateFolder();
        }
    }


    return (
        <Modal isOpen={isModalOpen} toggleModal={toggleModal} heading='Create a folder' additionalclasses='lg:min-w-[380px]'>
            <div className='grid gap-[16px] justify-items-end'>
                <div className='grid gap-[4px]'>
                    <Input
                        ref={inputRef}
                        placeholder='Folder name'
                        onChange={(e) => { setInputValue(e.target.value) }}
                        onKeyDown={handleKeyDown}
                        additionalclasses='lg:!min-w-[348px] m-auto'
                    />
                    {showError && disabledError && (
                        <p className='text-[12px] custom-text-danger-500'>{disabledError} *</p>
                    )}
                </div>
                {isCreatingFolder ? (
                    <Spinner />
                ) : (
                        <FitButton disabled={inputValue == ''} onClick={handleCreateFolder} >
                            <ButtonContent>Create</ButtonContent>
                        </FitButton>
                )}
            </div>
        </Modal>
    );
};

export default CreateFolderModal;